<template>
  <div class="private-enterprise">
    <div class="title">
      <span>广东省民营企业主体</span>
    </div>
    <div class="chart-con">
      <TabList
        class="po"
        :list="tabList"
        :act="tabIndex"
        @clickItem="
          (item, i) => {
            tabIndex = i;
          }
        "
      ></TabList>
      <v-chart ref="line-chart" id="line-chart" class="line-chart" :options="chartOption" />
    </div>
  </div>
</template>

<script>
import drawLine from '../chartJs/privateEnterpriseLine';
import { getAlarmReason, getUseRate, getLumpSum } from '@/api/privateEnterprise';
import TabList from '../../../components/tabList';
import drawBar from '../chartJs/chartGDPAndGrowth';
export default {
  name: 'PrivateEnterprise',
  components: { TabList },
  props: {
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      tabList: [
        {
          key: 0,
          label: '单位',
        },
        {
          key: 1,
          label: '从业人数',
        },
      ],
      tabIndex: 0,
      chartOption: null,
      alarmFreData: {},
    };
  },
  computed: {
    keyName() {
      return this.tabIndex ? '人数' : '总额';
    },
  },
  watch: {
    tabIndex(n) {
      this.getAllData();
    },
  },
  methods: {
    getAllData() {
      this.$refs['line-chart'].clear();
      this.$api.screen
        .getPrivateEnterprises({
          caliber: this.tabList[this.tabIndex].label,
          endYear: this.yearP,
        })
        .then((res) => {
          let { data } = res.data;
          let listData = {};
          if (data && data.yData?.length) {
            let fI = 0,
              lI = data.yData[0].data.length;
            data.yData.map((item) => {
              item.name = item.name.slice(0, 2);
              const firstIndex = item.data.findIndex((x) => x !== null && x !== '');
              const lastIndex = item.data.findLastIndex((x) => x !== null && x !== '') + 1;
              if (firstIndex !== -1 && firstIndex > fI) fI = firstIndex;
              if (lastIndex !== -1 && (lI === item.data.length || lastIndex > lI)) {
                lI = lastIndex;
              }
              listData[item.name] = item.data;
            });
            listData['年份'] = data.xData;
            for (const key in listData) {
              if (Object.hasOwnProperty.call(listData, key)) {
                const element = listData[key];
                listData[key] = element.slice(fI, lI);
              }
            }
          }
          let list = [];
          for (let i = 0; i < listData['年份'].length; i++) {
            let obj = {
              年份: listData['年份'][i],
              私营: '',
              个体: '',
            };
            for (let key in listData) {
              obj[key] = listData[key][i];
            }
            list.push(obj);
          }
          this.lineRateData = list;
          this.chartOption = drawLine(list, this.tabIndex ? '万人' : '万个');
        });

      // getLumpSum().then((res) => {
      //   let type = this.tabList[this.tabIndex].label;
      //   let data = res.RECORDS.filter(item => item['类型'] === type);
      //   let year = new Set();
      //   let lineName = new Set();
      //   data.map((item) => {
      //     year.add(item['年份']);
      //     lineName.add(item['指标']);
      //   });
      //   this.$nextTick(() => {
      //     this.alarmFreData.year = Array.from(year);
      //     this.alarmFreData.lineName = Array.from(lineName);
      //     let lineName1 = `私营单位${this.tabIndex ? '从业人数' : '主体数'}`;
      //     let lineName2 = `个体单位${this.tabIndex ? '从业人数' : '主体数'}`;
      //     this.alarmFreData.dpx_plc = this.getData(data, lineName1 , '总数', '指标');
      //     this.alarmFreData.nsx_plc = this.getData(data, lineName2, '总数', '指标');
      //     let dataObj = this.alarmFreData;
      //     let list = []; //报警频次
      //     for (let i = 0; i < 6; i++) {
      //       list.push({
      //         年份: dataObj.year[i],
      //         lineName1: dataObj.dpx_plc[i],
      //         lineName2: dataObj.nsx_plc[i],
      //       });
      //     }
      //     console.log(list, '-list')
      //     this.lineRateData = list;
      //     this.chartOption = drawLine(list, data[0]['单位']);
      //   });
      // });
    },
    getData(data, name, keyName, label) {
      let arr = [];
      for (let key = 0; key < data.length; key++) {
        if (data[key][label] === name) {
          arr.push(Number(data[key][keyName]));
        }
      }
      return arr;
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['line-chart'].clear();

        this.chartOption = drawLine(this.lineRateData, true);
      });
    },
  },
  mounted() {
    this.getAllData();
  },
};
</script>

<style lang="less" scoped>
.private-enterprise {
  .chart-box();
}
</style>
